import _ from 'lodash';
import moment from "moment/moment";
import addEmployeeModal from "../../../common/modals/addEmployeeModal/addEmployeeModal.component";

class EmployeesController {
  constructor(AuthenticationService, $rootScope, $http, toastr, $uibModal) {
    "ngInject";
    this.authenticationService = AuthenticationService;
    this.name = 'employees';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.employees = [];
    let self = this;
    this.showInactiveEmployees = false;
    this.toastr = toastr;
    this.$uibModal = $uibModal;

    this.userFilter = {
      fullName: '',
      status: 'active',
      userType: 'all'
    }

    this.filterrefresh = false

    this.userColumns = [
      {
        displayName: '',
        value: 'id',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return "<a href=\"/admin/employees/"+record.id+"\" ui-sref=\"admin.employee-details({'employeeId': "+record.id+"})\" ng-click=\"$ctrl.checkPermission($event, 'PERM_MANAGE_EMPLOYEE_DETAILS')\"><h5 style='margin:0px;padding:0px;width:30px;height:30px;border-radius:15px;text-align:center;line-height:30px;background:lightgoldenrodyellow'>"+record.firstName.charAt(0)+record.lastName.charAt(0)+"</h5></a>";
        }
      },
      {
        displayName: 'First Name',
        value: 'firstName',
        sortable: true,
        dataType: 'text'
      },
      {
        displayName: 'Last Name',
        value: 'lastName',
        sortable: true,
        dataType: 'text'
      },
      {
        displayName: 'Status',
        value: 'employmentStatus',
        sortable: true,
        dataType: 'text'
      },
      {
        displayName: 'Hire Date',
        value: 'startDate',
        sortable: true,
        dataType: 'date',
        formatting: function (record) {
          return moment(record.startDate).format("MMM DD YYYY");
        }
      },
      {
        displayName: 'Title',
        value: 'title',
        dataType: 'text',
        sortable: true
      },
      {
        displayName: 'User Name',
        value: 'userName',
        dataType: 'text',
        sortable: true
      },
      {
        displayName: 'Address',
        value: 'address',
        dataType: 'text',
        sortable: true
      },
      {
        displayName: 'Phone',
        value: 'phone',
        dataType: 'text',
        sortable: true
      }
    ];

    this.filterCriteria = function () {
      return "fullName="+self.userFilter.fullName+"&status="+self.userFilter.status+"&userType="+self.userFilter.userType;
    }

  }

  filterEmployees() {
    this.filterrefresh = true
  }

  checkPermission(e, permission) {
    if(!this.authenticationService.hasPermission(permission)){
      console.log(e);
      e.preventDefault();
      e.stopPropagation();
    }
  }

  getFilteredEmployees() {
    let employeeList = this.employees;

    if(this.showInactiveEmployees == false) {
      employeeList = _.filter(this.employees, function (employee) {
        return employee.active;
      });
    }


    return employeeList;
  }

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      phoneNumberString = '(' + match[1] + ') ' + match[2] + '-' + match[3]
      return true;
    }

    return false;
  }

  getEmployees() {
    let self = this;

    if(this.employeeFilter && this.employeeFilter.length > 0) {
      return _.filter(this.employees, function (employee) {
        let name = employee.firstName + ' ' + employee.lastName;
        return name.toLowerCase().includes(self.employeeFilter.toLowerCase());
      });
    } else {
      return this.employees;
    }
  }

  getAvatarUrl() {
    return this.$rootScope.apiHost+"/api/users/me/avatar?"+this.$rootScope.profilePicTimeStamp;
  }

  activeEmployeeCount() {
    let x =  _.filter(this.employees, function (employee) {
      return employee.active;
    });

    return x.length;
  }

  inactiveEmployeeCount() {
    let x =  _.filter(this.employees, function (employee) {
      return !employee.active;
    });

    return x.length;
  }

  addEmployee() {
    let self = this;
    var modalInstance = this.$uibModal.open(addEmployeeModal);

    modalInstance.success = function () {
      self.toastr.success("The employee Was Created Successfully!", "Employee Created");
      // self.$state.go("admin.project-details", {'projectId': project.id} );
      modalInstance.dismiss();
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

  updateUserDetails(employeeId, parameter, value) {

    let self = this;
    let obj = {};
    obj[parameter] = value;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/users/"+employeeId, obj, {withCredentials: true}).then(function (success) {
      self.employee = success.data;
      self.toastr.success("Employee Updated!", "SUCCESS");
    }, function (failure) {
      self.toastr.error("Could not update user.", "ERROR");
    });
  }


  filterContracts() {
    this.userFilterRefresh = true;
  }


}

export default EmployeesController;



// WEBPACK FOOTER //
// ./client/pages/admin/employees/employees.controller.js